import axios from 'axios';
import qs from 'qs';
import getApiUrl from "src/utils/get-api-url";

const apiUrl = getApiUrl();
const paramsSerializer = (params) => qs.stringify(params, { arrayFormat: 'repeat' });

/**
 * Get paginated Fit History records with optional filters.
 *
 * @param {Object} [filters]
 * @param {string} [filters.login]
 * @param {Array<string>} [filters.allianceAndGu]
 * @param {Array<string>} [filters.pdm]
 * @param {Array<string>} [filters.role]
 * @param {Array<string>} [filters.positionMap]
 * @param {Object} [pagination]
 * @param {number} [pagination.currentPage]
 * @param {number} [pagination.limit]
 * @returns {Promise<Object>}
 */
export function list(filters = {}, pagination = {}, sort = {}, lang) {
    return axios.get(`${apiUrl}/reports/fit`, {
        params: { ...filters, ...pagination, ...sort, lang },
        paramsSerializer,
    });
}

/**
 * Get filter options for Fit History.
 *
 * @returns {Promise<Object>}
 */
export function getFilters() {
    return axios.get(`${apiUrl}/reports/fit/filters`);
}

/**
 * Export Fit History records in the specified format.
 *
 * @param {string} format - Export format: 'csv', 'xlsx' or 'pdf'.
 * @param {string} lang - Language code: 'en' or 'pt-BR'.
 * @returns {Promise<Object>}
 */
export function exportReport(format, lang) {
    return axios.get(`${apiUrl}/reports/fit/export`, {
        params: { format, lang },
        paramsSerializer,
        responseType: 'blob',
    });
}
